import * as React from "react";
import { SvgIcon } from "@origin-digital/ods-icons";
import { IconButton } from "@mui/material";
import styled from "styled-components";

interface IAsyncMessengerIconProps {
  onClick: () => void;
  customLauncherSelector: string;
}

const StickyWidget = styled(IconButton)({
  position: "fixed",
  bottom: "5px",
  right: "5px",
});

export const AsyncMessengerIcon = ({
  onClick,
  customLauncherSelector,
}: IAsyncMessengerIconProps): JSX.Element => {
  return (
    <StickyWidget
      id={customLauncherSelector}
      data-id={customLauncherSelector}
      onClick={onClick}
    >
      <SvgIcon size="large" viewBox="0 0 60 60">
        <g
          id="Assets"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="intercom-help_launcher_yellow-circle_02"
            transform="translate(-3.000000, -3.000000)"
          >
            <g transform="translate(3.000000, 3.000000)">
              <circle id="Oval" fill="#FB7450" cx="30" cy="30" r="30" />
              <g id="chat-24px" transform="translate(15.000000, 15.000000)">
                <polygon id="Path" points="0 0 30 0 30 30 0 30" />
                <path
                  d="M25,2.5 L5,2.5 C3.625,2.5 2.5125,3.625 2.5125,5 L2.5,27.5 L7.5,22.5 L25,22.5 C26.375,22.5 27.5,21.375 27.5,20 L27.5,5 C27.5,3.625 26.375,2.5 25,2.5 Z M7.5,11.25 L22.5,11.25 L22.5,13.75 L7.5,13.75 L7.5,11.25 Z M17.5,17.5 L7.5,17.5 L7.5,15 L17.5,15 L17.5,17.5 Z M22.5,10 L7.5,10 L7.5,7.5 L22.5,7.5 L22.5,10 Z"
                  id="Shape"
                  fill="#FFFFFF"
                  fillRule="nonzero"
                />
              </g>
            </g>
          </g>
        </g>
      </SvgIcon>
    </StickyWidget>
  );
};
